import React, { useRef } from 'react'
import { LinearProgress } from '@mui/material'
import { t } from 'i18next'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTimes } from '@fortawesome/free-solid-svg-icons'
import ToolTipInformation from 'Components/ToolTipInformation/ToolTipInformation'

function CustomerDisplayFileUpload({
  fileName,
  fileUrl,
  accept,
  maxSize,
  isUploading,
  uploadProgress,
  onFileSelected,
  onRemoveFile,
}) {
  const fileInputRef = useRef(null)

  const handleSelectFileClick = () => {
    fileInputRef.current?.click()
  }

  return (
    <div className="customer-display-file-upload">
      <div className="field-details-container">
        <label className="customer-display-label">
          {t('CUSTOMER_DISPLAY_SETTINGS.FORM.FILE')}
          <span className="required">*</span>
        </label>
        <ToolTipInformation
          message={
            <p style={{ fontSize: '12px' }}>
              {t('CUSTOMER_DISPLAY_SETTINGS.FORM.MAX_SIZE')}: {maxSize} MB
            </p>
          }
        />
      </div>

      <div className="customer-display-file-row">
        <button
          type="button"
          className="customer-display-file-button customer-display-file-select-button"
          disabled={isUploading}
          onClick={handleSelectFileClick}
          data-testid="btn-select-file">
          {fileName || t('CUSTOMER_DISPLAY_SETTINGS.FORM.SELECT_FILE')}
        </button>
        <input
          ref={fileInputRef}
          className="customer-display-file-input"
          type="file"
          accept={accept}
          onChange={onFileSelected}
        />

        {fileUrl && (
          <button
            type="button"
            className="customer-display-file-button customer-display-file-remove-button"
            onClick={onRemoveFile}
            data-testid="btn-remove-file">
            <FontAwesomeIcon icon={faTimes} size="2x" />
          </button>
        )}
      </div>

      {isUploading && (
        <LinearProgress
          variant="determinate"
          value={uploadProgress}
          className="customer-display-upload-progress"
        />
      )}
    </div>
  )
}

export default CustomerDisplayFileUpload
